import { useRouter } from '@bprogress/next/app';
import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';
import { utilEventCartModal } from '@/fo/util/event-cart-modal';

import { styles } from './AuthModal.styles';

export interface AuthModalProps {
  hideGuestCheckout: boolean;
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
}

export function AuthModal({
  hideGuestCheckout,
  isModalOpen,
  setIsModalOpen
}: AuthModalProps) {
  const slots = styles();
  const t = useTranslations();
  const router = useRouter();

  const handleProceedToCheckout = () => {
    setIsModalOpen(false);
    utilEventCartModal.close();
    router.push('/checkout');
  };

  return (
    <UiKitDrawerBase
      contentClassName={slots.base()}
      title={t('LoginToAccount')}
      open={isModalOpen}
      onOpenChange={setIsModalOpen}
      direction="right"
    >
      <h3 className={slots.title()}>{t('LoginToAccount')}</h3>
      <p className={slots.description()}>
        {t('Sign in to start earning points and cashback')}
      </p>

      <div className={slots.buttons()}>
        {!hideGuestCheckout && (
          <UiKitButtonBase
            color="secondary"
            as="button"
            onClick={() => handleProceedToCheckout()}
          >
            {t('Continue as a guest')}
          </UiKitButtonBase>
        )}
        <UiKitButtonBase
          onClick={() => {
            utilEventAuthModal.open('cart');
          }}
        >
          {t('LoginToPersonalAccount')}
        </UiKitButtonBase>
      </div>
    </UiKitDrawerBase>
  );
}
